/**
 * Common translations - English
 */

export default {
  language_switch: 'Language Switch',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  confirm: 'Confirm',
  cancel: 'Cancel',
  close: 'Close',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  search: 'Search',
  submit: 'Submit',
  reset: 'Reset',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  more: 'More',
  less: 'Less',
  all: 'All',
  viewDetails: 'View Details',
  learnMore: 'Learn More',
  contactUs: 'Contact Us',
  readMore: 'Read More',
  download: 'Download',
  comingSoon: 'Coming Soon',
  clickToLocate: 'Click to locate on the map',
  mapOverview: 'Map Overview',
  regionContactCenter: 'Regional Service Center',
  serviceNodes: 'Service Centers',
  serviceRegionsLabel: 'Service Regions',
  coverageCapability: 'Coverage',
  localSupport: 'Local Support',
  asiaPacificServiceNetwork: 'Asia-Pacific Service Network',
  clickCardToLocate: 'Click a region card on the right to quickly locate the corresponding service center.',
  searchRegionPlaceholder: 'Search region / city / address',
  zoomIn: 'Zoom In',
  zoomOut: 'Zoom Out',
  resetView: 'Reset',
  staticMapPreview: 'Static Map View',
  staticMapNote: 'This visual is used to present service coverage and does not rely on third-party map services.',
  step: 'Step',
  standardizedDeliveryPath: 'Standardized Delivery Path',
  serviceProcessIntro: 'From early-stage requirement alignment to continuous optimization, the service process is advanced in clearly defined phases so clients can understand each delivery milestone more intuitively.',
  phase: 'Phase',
  openChat: 'Open chat',
  closeChat: 'Close chat',
  customerService: 'Customer Service',
  send: 'Send',
  invalidType: 'Please select a type',
  invalidRegion: 'Please select a service region',
  invalidCompanyName: 'Please enter the company name',
  invalidContactName: 'Please enter the contact name',
  invalidPosition: 'Please enter the position',
  invalidEmail: 'Please enter an email address',
  invalidEmailFormat: 'Please enter a valid email address',
  invalidPhone: 'Please enter a phone number',
  invalidPhoneFormat: 'Please enter a valid phone number',
  invalidIndustry: 'Please select an industry',
  invalidCompanySize: 'Please select a company size',
  invalidServices: 'Please select at least one interested service',
  invalidMessage: 'Please describe your project requirements',
  requestFailed: 'Request failed',
  badRequest: 'Invalid request parameters',
  unauthorized: 'Unauthorized. Please log in again.',
  forbidden: 'You do not have permission to access this resource.',
  notFound: 'The requested resource was not found.',
  serverError: 'Internal server error',
  badGateway: 'Bad gateway',
  serviceUnavailable: 'Service is temporarily unavailable',
  requestFailedWithStatus: 'Request failed with status code: {status}',
  requestTimeout: 'The request timed out. Please try again later.',
  networkError: 'Network connection failed. Please check your connection.',
  submitFailedRetry: 'Submission failed. Please try again later.',
  submitFailedCheck: 'Please check whether the information you entered is correct.',
  submitFailedServer: 'The server is temporarily unable to process your request. Please try again later.',
  submitFailedNetwork: 'Network connection failed. Please check your connection and try again.',
  ticketList: {
    newTicket: 'New Ticket',
    unassigned: 'Unassigned',
    progressLabel: 'Progress: {progress}%',
    status: {
      pending: 'Pending',
      inProgress: 'In Progress',
      completed: 'Completed'
    },
    samples: {
      networkIssue: 'Network Connectivity Issue',
      softwareInstall: 'Software Installation Issue',
      systemOptimization: 'System Performance Optimization',
      supportA: 'Technical Support A',
      supportB: 'Technical Support B'
    }
  },
  share: 'Share',
  copy: 'Copy',
  copied: 'Copied',
  required: 'Required',
  optional: 'Optional',
  placeholder: 'Please enter...'
}
